import { type i18n } from 'i18next'
import { DEFAULT_LANGUAGE, Language } from './constants'

export const NOT_AVAILABLE_TEXT = 'N/A'
export const UNDEFINED_TEXT = 'undefined'

export function trans<R extends Record<string, unknown>, K extends keyof R>(
  i18n: i18n,
  translations: R[],
  key: K,
  langKey: string = 'language_code',
): R[K] | typeof NOT_AVAILABLE_TEXT | typeof UNDEFINED_TEXT {
  // It will return undefined if translations is not defined
  if (!translations) return UNDEFINED_TEXT

  const currentLanguage = i18n.language
  const translation =
    translations.find((t) => t[langKey] === currentLanguage) ??
    translations.find((t) => t[langKey] === DEFAULT_LANGUAGE) ??
    translations[0] ??
    undefined
  return translation?.[key] ?? NOT_AVAILABLE_TEXT
}

// Type guard to check if a string is a valid Language
export const isLanguage = (value: unknown): value is Language => {
  if (typeof value !== 'string') return false
  return Object.values(Language).some((lang) => lang === value)
}

// Parse language to valid Language
export function parseLanguage(lang: string): Language {
  if (!isLanguage(lang)) {
    return DEFAULT_LANGUAGE
  }
  return lang
}
